module.exports = __webpack_public_path__ + "img/compentation_service_primary.bc904402.svg";